import RejectTradeAgreement from './RejectTradeAgreement';

export default RejectTradeAgreement;
